import {
  CLEAR_HTTP_MESSAGES,
  ADD_ERROR_MESSAGE,
  ADD_SUCCESS_MESSAGE,
  STORAGE_OVERUSED_ERROR,
} from "~/store/action_types";

export const clearHttpMessages = () => {
  return {
    type: CLEAR_HTTP_MESSAGES,
  };
};

/**
 * @deprecated - switch to showErrorToast(message, config?)
 */
export const addErrorMessage = (message) => {
  return {
    type: ADD_ERROR_MESSAGE,
    message,
  };
};

/**
 * @deprecated - switch to showSuccessToast(message, config?)
 */
export const addSuccessMessage = (message, timeout) => {
  return {
    type: ADD_SUCCESS_MESSAGE,
    message,
    timeout,
  };
};

export const storageOverusedError = (error) => {
  return {
    type: STORAGE_OVERUSED_ERROR,
    error,
  };
};
